var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoBrandCustomer = function SvgLogoBrandCustomer(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 163.501,
    height: 30,
    viewBox: "0 0 163.501 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2114",
    "data-name": "Gruppe 2114",
    transform: "translate(-54.499 -10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2113",
    "data-name": "Gruppe 2113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2112",
    "data-name": "Gruppe 2112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10384",
    "data-name": "Pfad 10384",
    d: "M210.658,13.98a12.681,12.681,0,0,0-8.678,3.177,10.631,10.631,0,0,0-3.039,7.981c0,8.578,7.417,10.845,11.339,10.845A26.2,26.2,0,0,0,218,34.7V24.124l-6.057,0v7.006a3.024,3.024,0,0,1-1.318.247c-.855,0-5.122-.293-5.122-6.079,0-4.515,1.827-6.71,5.715-6.71a18.8,18.8,0,0,1,5.2,1.062l.662-4.572a21.773,21.773,0,0,0-6.419-1.1Z",
    fill: "#ed7100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10385",
    "data-name": "Pfad 10385",
    d: "M142,14.546h-6.3l-7.85,20.841,6.328,0,1.1-3.243h7.158l1.1,3.243,6.33,0Zm-5.42,13.227,2.267-6.6,2.269,6.6Z",
    fill: "#ed7100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10386",
    "data-name": "Pfad 10386",
    d: "M172.565,14.546l-1.96,8.3c-.2.857-1.181,5.278-1.2,5.406-.021-.128-1-4.549-1.2-5.406l-1.959-8.3h-5.652l-1.958,8.3c-.2.857-1.183,5.278-1.2,5.406-.023-.128-1-4.549-1.205-5.406l-1.958-8.3H148.1l5.669,20.837h6.577l1.746-6.738c.222-.857,1.3-5.276,1.32-5.405.024.129,1.1,4.548,1.319,5.405l1.746,6.738h6.579l5.667-20.837Z",
    fill: "#ed7100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10387",
    "data-name": "Pfad 10387",
    d: "M191.131,14.546h-6.3l-7.851,20.841,6.33,0,1.1-3.243h7.159l1.094,3.243,6.33,0Zm-5.42,13.227,2.268-6.6,2.268,6.6Z",
    fill: "#ed7100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10388",
    "data-name": "Pfad 10388",
    d: "M129.668,14.546H113.4V19.4h5.011V35.383h6.324V19.4h4.937Z",
    fill: "#ed7100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10389",
    "data-name": "Pfad 10389",
    d: "M112.924,29.033c0-4.314-3.827-5.605-6.359-6.458l-1.2-.4c-1.627-.554-2.865-1.072-2.793-2.284.057-.946.9-1.408,2.593-1.408a22.829,22.829,0,0,1,5.5,1.011l.683-4.443a18.9,18.9,0,0,0-6.349-1.06c-2.3,0-5.451.385-7.343,2.226a5.668,5.668,0,0,0-1.634,4.237c0,3.9,3.466,5.192,6,6.135l2.192.828c1.315.5,2.352.894,2.219,2.295-.151,1.571-2.034,1.741-2.836,1.741A38.036,38.036,0,0,1,96.708,30l-.686,4.638a35.6,35.6,0,0,0,6.943,1.347c3.777.162,6.529-.554,8.158-2.116a6.409,6.409,0,0,0,1.8-4.831Z",
    fill: "#ed7100"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10390",
    "data-name": "Pfad 10390",
    d: "M54.544,25.567C55.407,19.083,67.168,13.1,74.85,10.088c.159-.06.337-.158.481-.011a.272.272,0,0,1,.026.343c-.652.982-7,10.281-8.81,16.874-.508,1.831-1.049,5.307.462,8.193,0,0,.144.19.043.348s-.218.151-.449.077c0,0-12.956-3.6-12.059-10.345",
    fill: "#ed7100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10391",
    "data-name": "Pfad 10391",
    d: "M67.362,39.923a.273.273,0,0,1-.026-.343c.652-.981,7-10.281,8.811-16.875.508-1.83,1.049-5.306-.462-8.192,0,0-.144-.191-.043-.348s.217-.152.449-.077c0,0,12.955,3.6,12.057,10.345-.862,6.485-12.622,12.464-20.305,15.48C67.684,39.973,67.506,40.07,67.362,39.923Z",
    fill: "#ed7100"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoBrandCustomer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-brand-customer.bd0c5e76d68345cced48d3a6ab9258cb.svg";